import { render, staticRenderFns } from "./AcquirerCostConfigList.vue?vue&type=template&id=6c972e1a&scoped=true&"
import script from "./AcquirerCostConfigList.vue?vue&type=script&lang=js&"
export * from "./AcquirerCostConfigList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c972e1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c972e1a')) {
      api.createRecord('6c972e1a', component.options)
    } else {
      api.reload('6c972e1a', component.options)
    }
    module.hot.accept("./AcquirerCostConfigList.vue?vue&type=template&id=6c972e1a&scoped=true&", function () {
      api.rerender('6c972e1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/settings/financial/acquirer-cost-config/AcquirerCostConfigList.vue"
export default component.exports